import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, of } from "rxjs";

import { environment } from "../../../environments/environment";
import { AuthService } from "../auth/auth.service";
import { HelperService } from "./helper.service";

@Injectable({
	providedIn: "root",
})
export class ImageService {
	constructor(private http: HttpClient, private authSvc: AuthService, private helperSvc: HelperService) {}

	getImageUser(filename?: string) {
		return environment.API_URL + "/util/getImage/usuarios/" + (filename || "no_user.png");
	}

	getImageUserMe(username: string) {
		return this.http.get(this.getImageUser(username), { responseType: "blob" }).pipe(
			map((response) => {
				console.log("ws getImageUserMe", response);
				return URL.createObjectURL(response);
			}),
			catchError((error) => {
				console.log("Error al obtener la imagen del usuario: ", error);
				return of(this.getImageUser(""));
			})
		);
	}

	generarQr(qrData: string, entorno?: string) {
		return new Observable<any>((observer) => {
			const accessToken = this.authSvc.getAccessToken();

			const headers = new HttpHeaders({
				Authentication: "Bearer " + accessToken,
				"Content-Type": "application/json; charset=utf-8",
			});

			const datos = {
				qrData,
				entorno,
			};

			const url = environment.API_URL + "/util/qr";
			this.http.post(url, datos, { responseType: "blob", headers: headers }).subscribe(
				(response: Blob) => {
					console.log("generar qr", response);
					// const file = new Blob([response], {type: 'application/pdf'});
					// const fileUrl = window.URL.createObjectURL(file);
					observer.next(response);
				},
				(err) => {
					console.log("error generar qr", err);
					observer.error(err);
				}
			);

			return { unsubscribe() {} };
		});
	}

	obtenerFichero(filePath: string, mime?: string) {
		return new Observable<any>((observer) => {
			const accessToken = this.authSvc.getAccessToken();

			const headers = new HttpHeaders({
				Authentication: "Bearer " + accessToken,
				"Content-Type": "application/octet-stream",
			});

			const params = {
				filePath,
				mime,
			};

			const url = environment.API_URL + "/util/get-file?" + this.helperSvc.serializeData(params);
			this.http.get(url, { responseType: "blob", headers: headers }).subscribe({
				next: (response: any) => {
					console.log("ws obtenerFichero", response);
					const file = new Blob([response], { type: response.type });
					const fileUrl = window.URL.createObjectURL(file);
					console.log("file url pdf", fileUrl);
					observer.next(fileUrl);
				},
				error: (err) => {
					console.log("error ws obtenerFichero", err);
					let msgError = "Se ha producido un error obteniendo el fichero";
					if (err.error.message) {
						msgError = err.error.message;
					}
					observer.error("err");
				},
			});

			return { unsubscribe() {} };
		});
	}
}
